module.exports = __webpack_public_path__ + "img/icon-address.1ab44e70.svg";